import Tooltip from 'antd/es/tooltip';
import styled from 'styled-components';

import Button from '@components/Button';

export const StyledCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 2px;
  width: 156px;
  height: 48px;
`;

export const CounterButton = styled(Button)`
  &&& {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;

    & > span[data-role='custom-icon'] {
      display: flex !important;
    }

    &:disabled {
      border: none;
      opacity: 1 !important;
      background-color: ${({ theme }) => theme.palette.grey200} !important;
    }
  }
`;

export const CounterButtonLabel = styled.span`
  margin: 0 12px;
  text-align: center;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const TourIncrementButtonWrapper = styled.div`
  pointer-events: true;
`;

export const TooltipStyle = styled(Tooltip)`
  &&& {
    .setur-tooltip-content .setur-tooltip-inner {
      min-width: 30px;
      min-height: 32px;
      padding: 6px 8px;
      text-align: left;
      text-decoration: none;
      background-color: ${({ theme }) => theme.palette.white} !important;
      border-radius: 1px;
      color: ${({ theme }) => theme.palette.darkGray} !important;
      font-size: 13px;
    }
    .setur-tooltip-arrow {
      position: absolute;
      display: block;
      width: 13px;
      height: 13px;
      overflow: hidden;
      background: transparent;
      pointer-events: none;
    }
  }
`;
